import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCalendarAlt, faTag } from '@fortawesome/free-solid-svg-icons';
import { announcements } from '../data/announcements';
import './Announcements.css';

// Import images
import duyurularHeroImage from '../assets/images/duyurular.jpg';

const Announcements = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "ProgenX Duyurular",
    "description": "ProgenX'in en güncel duyuruları, haberler, etkinlikler ve kampanyalar",
    "url": "https://progenxacademy.com/duyurular",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": announcements.map((announcement, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "NewsArticle",
          "headline": announcement.title,
          "datePublished": announcement.date,
          "url": `https://progenxacademy.com/duyurular/${announcement.slug}`,
          "description": announcement.excerpt
        }
      }))
    }
  };

  return (
    <div className="announcements">
      <Helmet>
        <title>ProgenX Duyurular | En Son Haberler ve Gelişmeler 2025</title>
        <meta name="description" content="ProgenX'in en güncel duyuruları, haberler, etkinlikler ve kampanyalar. Eğitim teknolojileri, yapay zeka ve yazılım alanındaki son gelişmelerden haberdar olun. TETZ 2025, AWS Activate, Teknogirişim Rozeti ve daha fazlası." />
        <meta name="keywords" content="progenx duyurular, progenx haberler, progenx kampanyalar, progenx etkinlikler, eğitim teknolojileri duyuruları, tetz 2025, aws activate, teknogirişim rozeti, progenx gelişmeler" />
        <meta property="og:title" content="ProgenX Duyurular | En Son Haberler ve Gelişmeler" />
        <meta property="og:description" content="ProgenX'in en güncel duyuruları, haberler ve etkinlikler. Eğitim teknolojileri alanındaki son gelişmelerden haberdar olun." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/duyurular" />
        <link rel="canonical" href="https://progenxacademy.com/duyurular" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      
      <Hero 
        title="DUYURULAR" 
        backgroundImage={duyurularHeroImage}
      />
      
      <section className="announcements-content">
        <div className="container">
          <h2 className="section-title">Son Duyurular</h2>
          <p className="announcements-intro">
            ProgenX'in eğitim teknolojileri, yapay zeka ve yazılım alanındaki en güncel gelişmeleri, 
            etkinlikleri ve başarılarını buradan takip edebilirsiniz.
          </p>
          
          <div className="announcements-list">
            {announcements.map(announcement => (
              <article 
                key={announcement.id}
                className={`announcement-card ${announcement.isHighlighted ? 'highlighted' : ''}`}
              >
                <div className="announcement-header">
                  <div className="announcement-meta">
                    <span className="announcement-category">
                      <FontAwesomeIcon icon={faTag} /> {announcement.category}
                    </span>
                    <span className="announcement-date">
                      <FontAwesomeIcon icon={faCalendarAlt} /> {announcement.date}
                    </span>
                  </div>
                </div>
                
                <h3 className="announcement-title">{announcement.title}</h3>
                <p className="announcement-excerpt">{announcement.excerpt}</p>
                
                <Link 
                  to={`/duyurular/${announcement.slug}`}
                  className="announcement-link"
                >
                  Devamını Oku
                  <FontAwesomeIcon icon={faArrowRight} />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Announcements;
